export function storageAvailable(type) {
  let storage;
  try {
    storage = window[type];
    let x = "__storage_test__";
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return (
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === "QuotaExceededError" ||
        // Firefox
        e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage &&
      storage.length !== 0
    );
  }
}

export const localStorageConstant = {
  closeReportWindow: "CLOSE_REPORT_WINDOW",
  finishReport: "FINISH_REPORT",
  endReview: "END_REVIEW",
  APP_LAYOUT: "APP_LAYOUT",
  STUDY_ATTACHMENT: "STUDY_ATTACHMENT",
  POP_IN_REPORT: "POP_IN_REPORT",
};
